<template>
  <v-app>
    <v-toolbar app color='white'>
      <img src="./assets/ex_logo.png" alt="Exemplar Logo">
      <Nav class='nav'/>
    </v-toolbar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <Footer />
  </v-app>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import Nav from './components/Nav.vue'
import Footer from './components/Footer.vue'

@Component({ components: { Nav, Footer } })
export default class App extends Vue {}
</script>

<style scoped>

img {
  height: 90%;
}

</style>
